<template>
  <div class="landing">
    <Header />
  </div>
</template>

<script>
import Header from '@/components/landing/Header.vue'

export default {
  components: {
    Header
  }
}
</script>

<style>

</style>
